import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['message-abstract-image-container'])
};
var _hoisted_2 = ["src"];
import { computed } from '../../../../../adapter-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-abstract-image',
  props: {
    messageContent: {
      default: () => ({})
    }
  },
  setup(__props) {
    var props = __props;
    var imageUrl = computed(() => props.messageContent.url || '');
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        class: _normalizeClass(['message-abstract-image']),
        src: _unref(imageUrl)
      }, null, 8, _hoisted_2)]);
    };
  }
});